export const categories = [
  {
    id: 1,
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    id: 2,
    name: 'Hoodies & Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    id: 3,
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
  },
  {
    id: 4,
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
  },
  {
    id: 5,
    name: 'Pants & Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
  },
  {
    id: 6,
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
  },
  {
    id: 7,
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
  },
  {
    id: 8,
    name: 'Underwear & Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
  },
  {
    id: 9,
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
  },
  {
    id: 10,
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
  },
  {
    id: 11,
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
  },
  {
    id: 12,
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
  },
  {
    id: 13,
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
  },
  {
    id: 14,
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';